import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertModalService } from './alertmodal.service';
import { AuAction } from '../../action/au.action';
import { PageService } from '../../models/page.service';
import { MessageService } from '../../service/message.service';
import { Error } from '../../models/error/error';
import { ConfigService } from '../../service/config.service';
var AlertModalComponent = /** @class */ (function () {
    function AlertModalComponent(router, route, action, message, page, service, config) {
        this.router = router;
        this.route = route;
        this.action = action;
        this.message = message;
        this.page = page;
        this.service = service;
        this.config = config;
        this.componentName = AlertModalComponent.name;
        this.app_base = this.config.config['app_base'] || '';
    }
    AlertModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var self = this;
        this.metaSubscription = this.page.meta().subscribe(function (meta) {
            _this.msgSnapshot = _this.message.getMessage();
        });
        this.subscription = this.service.observable.subscribe(function (data) {
            if (typeof data !== 'undefined' && typeof data.params !== 'undefined' && $('#alertModalRoot[class^="alertModal-"]').length === 0) {
                var params = data.params;
                var message = params.message;
                if (data.error && data.error.message) {
                    message = data.error.message;
                }
                $('.alertModal_msg', $('#alertModal')).text(message);
                $('.alertModal_btns', $('#alertModal')).empty();
                for (var i = 0; i < params.buttons.length; i++) {
                    var button = params.buttons[i];
                    var type_1 = button.type ? button.type : 'submit';
                    $('.alertModal_btns', $('#alertModal')).append('<li><button type="' + type_1 + '" class="alertModal_btns-' + button.class +
                        '" data-event="' + button.event + '">' + button.caption + '</button></li>');
                }
                var type_2 = 'alertModal-normal';
                if (data.error && data.error.type) {
                    type_2 = 'alertModal-' + data.error.type;
                }
                else if (params.type) {
                    type_2 = 'alertModal-' + params.type;
                }
                $('#alertModalRoot').addClass(type_2);
                var modal_1 = $.featherlight($('#alertModal'), {
                    root: '#alertModalRoot',
                    otherClose: 'button',
                    afterClose: function (e) {
                        var event;
                        if (e && e.target && $(e.target).parent('li').parent('ul').hasClass('alertModal_btns')) {
                            event = e.target.attributes.getNamedItem('data-event').value;
                        }
                        else {
                            // ボタンクリック以外でクローズされた
                            event = 'other';
                        }
                        $('.alertModal_msg', $('#alertModal')).empty();
                        $('.alertModal_btns', $('#alertModal')).empty();
                        $('#alertModalRoot').removeClass(type_2);
                        self.setScroll(this._previouslyActive, data.error);
                        self.action.setError(data.initEvent, new Error());
                        self.action.action(data.initEvent, event);
                    }
                });
                if (params.buttons.length === 0 && typeof params.timeout !== 'undefined') {
                    window.setTimeout(function () {
                        modal_1.close();
                    }, params.timeout);
                }
            }
        });
        this.reloadSubscription = this.service.reloadObservable.subscribe(function () {
            if ($('#alertModalRoot[class^="alertModal-"]').length === 0) {
                $('.alertModal_msg', $('#alertModal')).text(_this.msgSnapshot['au.COMPONENT.AlertModalComponent.modal.label.reload']);
                $('.alertModal_btns', $('#alertModal')).empty();
                $('.alertModal_btns', $('#alertModal')).append('<li><button type="button" class="alertModal_btns-ok">' +
                    _this.msgSnapshot['au.COMPONENT.AlertModalComponent.modal.button.reload'] + '</button></li>');
                var type_3 = 'alertModal-prohibit';
                $('#alertModalRoot').addClass(type_3);
                $.featherlight($('#alertModal'), {
                    root: '#alertModalRoot',
                    otherClose: 'button',
                    closeOnClick: false,
                    closeOnEsc: false,
                    afterClose: function (e) {
                        $('.alertModal_msg', $('#alertModal')).empty();
                        $('.alertModal_btns', $('#alertModal')).empty();
                        $('#alertModalRoot').removeClass(type_3);
                        window.location.href = self.app_base;
                    }
                });
            }
        });
    };
    AlertModalComponent.prototype.setScroll = function (element, error) {
        if (typeof error !== 'undefined' && typeof error.message !== 'undefined') {
            $(element).one('focus', function () {
                window.scrollTo(0, 0);
            });
        }
    };
    AlertModalComponent.prototype.ngOnDestroy = function () {
        this.metaSubscription.unsubscribe();
        this.subscription.unsubscribe();
        this.reloadSubscription.unsubscribe();
    };
    AlertModalComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'alertmodal',
                    template: "<div class=\"alertModal\" id=\"alertModal\">\n  <p class=\"alertModal_msg\"></p>\n  <ul class=\"alertModal_btns\"></ul>\n</div>\n<div id=\"alertModalRoot\">\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    AlertModalComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AlertModalService },
        { type: ConfigService }
    ]; };
    return AlertModalComponent;
}());
export { AlertModalComponent };
//# sourceMappingURL=alertmodal.component.js.map